import { render, staticRenderFns } from "./ServiceAssessmentSubjectiveData.vue?vue&type=template&id=1122ed0c&scoped=true"
import script from "./ServiceAssessmentSubjectiveData.vue?vue&type=script&lang=js"
export * from "./ServiceAssessmentSubjectiveData.vue?vue&type=script&lang=js"
import style0 from "./ServiceAssessmentSubjectiveData.vue?vue&type=style&index=0&id=1122ed0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1122ed0c",
  null
  
)

export default component.exports